import type { DeepWritable } from '@cmg/common';
import { getDataSource } from '@cmg/data-grid';
import { useMemo } from 'react';

import type { FirmInvestorContactsGridItemFragment } from '../graphql/__generated__';
import { useFirmsInvestorContactsGridQuery } from './useFirmsInvestorContactsGridQuery';

type FirmsInvestorContactsGridDataSourceParams = {
  tenantId?: string;
  firmId: string;
};

export function useFirmsInvestorContactsGridDataSource({
  firmId,
  tenantId,
}: FirmsInvestorContactsGridDataSourceParams) {
  const loadRows = useFirmsInvestorContactsGridQuery(tenantId);

  return useMemo(() => {
    return getDataSource({
      getData: async variables => {
        const { data, error } = await loadRows({
          ...variables,
          firmId,
        });
        if (error) {
          throw error;
        }
        return {
          rowData: (data?.investorFirmsGrid?.items?.[0]?.investorContacts?.items ??
            []) as DeepWritable<FirmInvestorContactsGridItemFragment[]>,
          rowCount: data?.investorFirmsGrid?.items?.[0]?.investorContacts?.totalCount ?? 0,
        };
      },
    });
  }, [loadRows, firmId]);
}
